import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import nl from '../locales/nl.json';
import en from '../locales/en.json';
import { safeGetItem, safeSetItem } from './safeStorage';

const STORAGE_KEY = 'customedge_lang';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      nl: { translation: nl },
      en: { translation: en },
    },
    lng: safeGetItem('local', STORAGE_KEY) ?? 'nl',
    fallbackLng: 'nl',
    interpolation: { escapeValue: false },
  });

export function setLanguage(lang: string) {
  i18n.changeLanguage(lang);
  safeSetItem('local', STORAGE_KEY, lang);
}

export default i18n;
